import React from 'react';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import _ from 'lodash';

export const CLASS_NAME_PREFIX = 'cl-gallery-el';

export const getPrefix = (className) => `${CLASS_NAME_PREFIX}-${className}`;

export const getThumbnail = (props) =>
  <label className={`${getPrefix('thumbnail')} ${props.id}`} key={props.key} htmlFor={props.id} data-interactive="true"
         dangerouslySetInnerHTML={{__html: `<span style="background-image: url('${props.src}')" data-interactive="true"></span>`}}
  />;

export const getImage = (props) =>
  <div className={`${getPrefix('slide')} ${props.id}`} key={props.key}
       style={_.assign({}, {height: props.height}, _.pick(props, PADDING_PROP_NAMES))}
       dangerouslySetInnerHTML={{__html: `<span style="background-image: url('${props.src}')"></span>`}}
  />;

export const getNavButton = (props) =>
  <label className={getPrefix('nav-button')}
         htmlFor={props.htmlFor}
         data-interactive="true"
         key={props.key}/>;

export const getInput = (props) =>
  <input id={props.id}
         name={props.name}
         type="radio"
         data-interactive="true"
         defaultChecked={props.defaultChecked}
         ref={props.ref}
         key={props.key}/>;

export const getNav = (props) =>
  <label htmlFor={props.htmlFor}
         key={props.key}
         data-interactive="true"
         className={props.labelClassName}>
    {props.showArrow ? <span className={props.arrowClassName} data-interactive="true" style={{opacity: 0.5}}/> :
      <span className={props.arrowClassName} data-interactive="true"/>}
  </label>;

export const getNextNav = (props) =>
  getNav(
    {
      ...props,
      labelClassName: `${getPrefix('nav-arrow-wrapper')} ${getPrefix('nav-arrow-wrapper-next')}`,
      arrowClassName: `${getPrefix('nav-arrow')} ${getPrefix('nav-arrow-next')}`
    });

export const getPrevNav = (props) =>
  getNav(
    {
      ...props,
      labelClassName: `${getPrefix('nav-arrow-wrapper')} ${getPrefix('nav-arrow-wrapper-prev')}`,
      arrowClassName: `${getPrefix('nav-arrow')} ${getPrefix('nav-arrow-prev')}`
    });

export const getThumbnailNextNav = (props) =>
  getNav(
    {
      ...props,
      labelClassName: `${getPrefix('nav-arrow-wrapper-thumbnails')} ${getPrefix('nav-arrow-wrapper-next-thumbnails')}`,
      arrowClassName: `${getPrefix('nav-arrow-thumbnails')} ${getPrefix('nav-arrow-next-thumbnails')}`
    });

export const getThumbnailPrevNav = (props) =>
  getNav(
    {
      ...props,
      labelClassName: `${getPrefix('nav-arrow-wrapper-thumbnails')} ${getPrefix('nav-arrow-wrapper-prev-thumbnails')}`,
      arrowClassName: `${getPrefix('nav-arrow-thumbnails')} ${getPrefix('nav-arrow-prev-thumbnails')}`
    });
